import { HTMLProps } from "react";

interface FeeAndGstProps extends HTMLProps<HTMLParagraphElement> {
  fee_cost?: number | string;
}

const FeeAndGst = ({ fee_cost, ...props }: FeeAndGstProps) => {
  return <p className="polymer-fees-700" {...props}>{typeof fee_cost === "number" ? `$${fee_cost?.toFixed(2)}` : fee_cost}</p>;
};

export default FeeAndGst;

